import axios from "axios";
import {
  IS_LOGIN,
  PERSIST_AUTH,
  SHOW_LOADING,
  HIDE_LOADING,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  IS_LOGOUT,
} from "./types";
import { MAIN_API } from "../../config/stepoutAPI";
import { trackEvent } from "../../utils/mixpanel";

export const LoginUser = (username, password) => {
  const formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);

  return async (dispatch) => {
    dispatch({ type: CLEAR_LOGIN_ERROR });
    dispatch({ type: SHOW_LOADING });
    try {
      const api_res = await axios.post(MAIN_API + "loginAnalyst/v2/", formData);

      const { response_data } = await api_res.data;

      if (Object.keys(response_data).length !== 0) {
        sessionStorage.setItem(
          "isAdmin",
          JSON.stringify({ status: response_data.is_admin })
        );
        sessionStorage.setItem("analyst_id", response_data.analyst_id);
        sessionStorage.setItem("token", response_data.token);
        sessionStorage.setItem("refresh_token", response_data.refresh_token);
        sessionStorage.setItem("analystName", response_data.analyst_name);
        sessionStorage.setItem("accountRole", response_data.role);
        sessionStorage.setItem(
          "tabsAccessible",
          JSON.stringify({ tabs: response_data.tabs_accessible })
        );

        dispatch({
          type: IS_LOGIN,
          payload: response_data.analyst_id,
          isAdmin: response_data.is_admin,
          token: response_data.token,
          analystName: response_data.analyst_name,
          accountRole: response_data.role,
          tabsAccessible: response_data.tabs_accessible,
        });

        // Mixpanel – identify user and track successful login
        trackEvent().init(response_data.analyst_id, response_data.analyst_name);
        trackEvent().track('clicked_on_login', {
          user_name: response_data.analyst_name,
          user_id: response_data.analyst_id,
          user_type: response_data.role,
        });
      }
    } catch (error) {
      dispatch({ type: HIDE_LOADING });
      dispatch({ type: LOGIN_ERROR });
      console.log("wrong credential", error.data);
    }
  };
};

export const LogoutUser = (queryClient) => {
  queryClient && queryClient.removeQueries();
  return async (dispatch) => {
    sessionStorage.clear();
    sessionStorage.removeItem("analyst_id");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("all_matches");
    dispatch({ type: IS_LOGOUT });
  };
};

export const CheckPersist = () => {
  return {
    type: PERSIST_AUTH,
  };
};
